import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import { Severities, ConformityLocations } from './enums'

export const NewUser = {
  username: '',
  displayName: '',
  originCompanyId: '-',
  allowedCompanies: [],
  allowedDepartments: [],
  email: '',
  groups: [],
  departmentId: '-',
  photo: '',
  userRole: '-',
  contractorId: '-',
  isActiveDirectory: false,
}

export const NewCompany = {
  name: 'NEW COMPANY',
  code: 'new_company',
  departments: [],
  contractors: [],
  workLocationId: '-',
}

export const NewDept = {
  nameDisplay: 'NEW DEPARTMENT',
  isAbleToView: true,
  isNew: true,
}

export const NewContractor = {
  name: '',
  code: '',
  contractorCategoryId: null,
  isActive: false,
}

export const NewCompanyContractor = {
  id: '-',
  CompanyContractor: {
    isActive: true,
  },
}

export const NewGroup = {
  name: '',
  isNew: true,
}

export const NewSupportRequest = {
  contractorId: '-',
  pitId: '-',
  title: '',
  description: '',
  severity: Severities[1].value,
  position: {
    x: '117.0354441',
    y: '-0.5093411',
    z: '0.00000',
  },
  seam: '-',
  sectionFrom: 0,
  sectionTo: 0,
  sectionPrefix: '',
  photo: [],
  photosBase64: [],
  concernedDepartment: '-',
  dateDeadline: new Date(),
  cc: [],
}

export const NewConformityReport = {
  contractorId: '-',
  pitId: '-',
  conformityCategoryId: '-',
  title: '',
  description: '',
  timeOccurence: new Date(),
  severity: Severities[1].value,
  position: {
    x: '117.0354441',
    y: '-0.5093411',
    z: '0.00000',
  },
  location: ConformityLocations[0].value,
  locationType: null,
  rootCause: '',
  dateDeadline: new Date(),
  seam: '-',
  sectionFrom: 0,
  sectionTo: 0,
  sectionPrefix: '',
  photo: [],
  photosBase64: [],
  anyFurtherAction: false,
  furtherActionDescription: '',
  concernedDepartment: '-',
  cc: [],
  hideSeamAndSection: true,
}

export const NewBargeLoading = {
  site: '-',
  noServicesTrip: '',
  loadingRequestId: null,
  loadingPlanId: null,
  tugName: '',
  bargeName: '',
  bargeSize: '',
  route: '',
  loadType: '-',
  coalQuality: '',
  arrivalTime: moment().format(),
  initialDraft: moment().format(),
  anchorUp: moment().format(),
  berthedTime: moment().format(),
  commencedLoading: moment().format(),
  completedLoading: moment().format(),
  unberthing: moment().format(),
  departure: moment().format(),
  delayCause: '-',
  delayCauseDuringBerthing: '-',
  surveyorName: '',
  waterLevelDuringLoading: null,
  cargoLoaded: [],
  fuelConsumption: {
    fuelRobRecords: [],
    grandTotal: 0,
  },
  draftSurvey: {
    draftSurveyRecords: [],
    averageDraftInitial: 0,
    averageDraftFinal: 0,
  },
  bargeSurvey: [],
  coalTemperature: {
    coalTemperatures: [],
    averageTemperature: 0,
  },
  attachments: [],
  deleteAttachments: [],
}

export const NewCargoLoaded = {
  tunnel: '-',
  percentageLoading: 0,
  beltScale: 0,
  draft: 0,
}

export const NewFuelConsumption = {
  fuelRobRecord: '-',
  liters: 0,
}

export const NewDraftSurvey = {
  draftSurveyRecord: '-',
  initial: 0,
  final: 0,
}

export const NewBargeSurvey = {
  bargeSurvey: '-',
  conditions: 0,
  remarks: '',
}

export const NewActualLoadingFinalize = {
  loadingDate: null,
  loadingDelayedDateTime: [],
  loadingDelayedUnit: [],
  loadingDelayedInformation: {
    tcm: 0,
    planBudgetTCM: 0,
    outlookTCM: 0,
    bek: 0,
    planBudgetBEK: 0,
    outlookBEK: 0,
    totalBlending: 0,
    blendingMTD: 0,
    blendingYTD: 0,
    MTD: 0,
    YTD: 0,
  },
  inProcessLoading: {
    tugboatBarge: '-',
    quality: '',
    planCargo: 0,
  },
  waitingTugboatBarge: [],
  summaryLossTime: {
    date: moment().format('DD-MMM-YYYY'),
    lossTime: '',
  },
  waterLevelWeather: {
    waterLevelToday: 0,
    weather: '-',
  },
}

export const NewDelayedInformationDateTime = {
  timeStart: moment().format(),
  timeEnd: moment().format(),
  remark: '',
}

export const NewWaitingTugBarge = {
  tugboatBarge: '',
  planCargoQuality: '',
  arrivalJetty: moment().format(),
}

// mock data for new blasting report
export const NewBlastingReport = {
  contractorId: '-',
  drillDate: new Date(),
  blastingDate: new Date(),
  details: {
    detailPit: [
      {
        id: uuidv4(),
        pitInfo: {
          pit: '-',
          sectionFrom: '',
          sectionTo: '',
          rl: '',
          negativeRl: false,
          actual: '',
          negativeActual: false,
          hole: '',
          negativeHole: false,
          hardness: '-',
          remark: '',
          powderFactor: '',
          volumeBlasting: '',
          explosiveUsage: '',
          rlDesign: '',
          negativeRlDesign: false,
        },
        geometri: {
          burden: '',
          spacing: '',
          depth: '',
          stemming: '',
          diameter: '-',
          numOfHole: '',
        },
        explosiveUsage: {
          explosiveType: '-',
          downToHole: '',
          amoniumNitrate: '',
          dynamites: [
            {
              id: uuidv4(),
              dynamiteType: '-',
              dynamiteWeight: '-',
              dynamiteAmount: '',
            },
          ],
          inholes: [
            {
              id: uuidv4(),
              inholeType: '-',
              inholeLength: '-',
              inholeAmount: '',
            },
          ],
          surfaces: [
            {
              id: uuidv4(),
              surfaceType: '-',
              surfaceLength: '-',
              surfaceAmount: '',
            },
          ],
          detonatorType: '-',
          detonatorAmount: '',
        },
        attachments: [],
      },
    ],
    blastingInventory: [
      {
        id: uuidv4(),
        pit: '-',
        positionType: '-',
        dailyVolume: '',
      },
    ],
  },
}

export const NewStockOpname = {
  companyCode: '-',
  areaCode: '',
  period: '',
  surveyDate: '',
  coalStockInventoryAttachments: [],
  coalStockInventoryDetails: [],
}
